<template>
    <div class="w-full overflow-hidden flex flex-col bg-card-bg rounded-2xl border-2">
        <div
            class="p-3 panel-head font-bold bg-gray-100 flex gap-3 justify-between items-center rounded-t-2xl cursor-pointer"
            @click="toggleSection"
        >
            <span class="capitalize">{{ title }}</span>
            <div class="flex gap-3 items-center">
                <span class="text-sm flex items-center gap-2">
                    <font-awesome-icon
                        icon="chevron-circle-up"
                        class="text-lg transition-all"
                        :class="{
                            'transform rotate-180': !isSectionExpanded,
                        }"
                    />
                </span>
            </div>
        </div>
        <div
            v-if="isSectionExpanded"
            class="w-full h-full p-4 gap-2 flex flex-col overflow-hidden bg-gray-100"
            @click.stop
        >
            <div class="w-full h-full grid auto-rows-max gap-y-3 overflow-auto scroll-bar ">
               <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>



export default {
    name: "TranslationListSection",
    components: {
    },
    props: {
        title: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isSectionExpanded: false
        };
    },
    methods: {
        toggleSection() {
            this.isSectionExpanded = !this.isSectionExpanded;
        }
    },
};
</script>
